exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.styleGeneral:hover {\n  text-decoration: underline;\n  -webkit-text-decoration-color: #51a45c;\n          text-decoration-color: #51a45c;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6620ca6e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/SettingsList/DocumentServiceSettings.vue
// module id = 1569
// module chunks = 2